import { IRutinFieldsPredicate } from '../RutinAvailabilityContext';
import { rutinInfos } from '../../../Const/RutinInfo';

/**
 * Specificering av urvalspredikat för rutiner som vill ha specialhantering
 */
export const rutinPredicates: { [rutin: number]: IRutinFieldsPredicate } = {
  [rutinInfos.rtnEkonomiskAnalys.rutinID]: {
    attributePredicate: () => {
      return true;
    },
    associationPredicate: () => {
      return false;
    },
  },
};
